export const SL_UPLOAD_DOMAINS_LIST_INFO_TEXT_POINT_1 = "si.management.subscribe-domains.list.info.text.point_1";
export const SL_UPLOAD_DOMAINS_LIST_INFO_TEXT_POINT_2 = "si.management.subscribe-domains.list.info.text.point_2";
export const SL_UPLOAD_DOMAINS_LIST_INFO_TEXT_POINT_3 = "si.management.subscribe-domains.list.info.text.point_3";
